import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { connect } from 'redaction'
import { compose } from 'common/helpers'

import Message from 'components/text/Message/Message'
import ProductResult from '../ProductResult/ProductResult'
import BrandResult from '../BrandResult/BrandResult'
import NoteResult from '../NoteResult/NoteResult'
import PageResult from '../PageResult/PageResult'

import messages from './messages'
import s from './SearchResults.scss'


const mergeHighlightResult = (item) => {
  if (!item._highlightResult) {
    return item
  }

  const newItem = { ...item }

  Object.keys(newItem._highlightResult).forEach((key) => {
    newItem[key] = newItem._highlightResult[key].value
  })

  delete newItem._highlightResult

  return newItem
}

const SearchResults = (props) => {
  const {
    query, items: { products = {}, brands = {}, notes = {}, pages = {} }, isFirstLoaded,
    onProductClick, onProductAdd, onBrandClick, onNoteClick, onPageClick,
  } = props

  const isProductsEmpty = products.hits && products.hits.length < 1
  const isBrandsEmpty = brands.hits && brands.hits.length < 1
  const isNotesEmpty = notes.hits && notes.hits.length < 1
  const isPagesEmpty = pages.hits && pages.hits.length < 1
  const isAllEmpty = isProductsEmpty && isBrandsEmpty && isNotesEmpty && isPagesEmpty

  if (!isFirstLoaded) {
    return <div className={cx(s.results, { [s.firstLoading]: !isFirstLoaded })} />
  }

  if (isAllEmpty) {
    return (
      <div className={s.results}>
        <div className={s.section}>
          <Message tag="div" className={cx(s.notFound, s.all)} text={messages.notFound.all} values={{ query }} />
        </div>
      </div>
    )
  }

  return (
    <div className={s.results}>
      <div className={cx(s.section, s.products, { [s.empty]: isProductsEmpty })}>
        <Message tag="div" className={s.title} text={messages.products} />
        {
          !isProductsEmpty
            ? (
              <ul className={s.list}>
                {
                  products.hits.map((product, index) => (
                    <li key={product.id}>
                      <ProductResult
                        index={index}
                        product={mergeHighlightResult(product)}
                        onClick={(data) => onProductClick({
                          ...data,
                          queryID: products.queryID,
                          indexName: products.indexName,
                        })}
                        onAdd={(data) => onProductAdd({
                          ...data,
                          queryID: products.queryID,
                          indexName: products.indexName,
                        })}
                      />
                    </li>
                  ))
                }
              </ul>
            )
            : (
              <Message tag="div" className={s.notFound} text={messages.notFound.products} values={{ query }} />
            )
        }
      </div>
      {
        /*
          <div className={cx(s.section, s.brands, { [s.empty]: isBrandsEmpty })}>
            <Message tag="div" className={s.title} text={messages.brands} />
            {
              !isBrandsEmpty
                ? (
                  <ul className={s.list}>
                    {
                      brands.hits.map((brand, index) => (
                        <li key={brand.name}>
                          <BrandResult
                            index={index}
                            brand={mergeHighlightResult(brand)}
                            onClick={(data) => onBrandClick({
                              ...data,
                              queryID: brands.queryID,
                              indexName: brands.indexName,
                            })}
                          />
                        </li>
                      ))
                    }
                  </ul>
                )
                : (
                  <Message tag="div" className={s.notFound} text={messages.notFound.brands} values={{ query }} />
                )
            }
          </div>
        */
      }
      <div className={cx(s.section, s.notes, { [s.empty]: isNotesEmpty })}>
        <Message tag="div" className={s.title} text={messages.notes} />
        {
          !isNotesEmpty
            ? (
              <ul className={s.list}>
                {
                  notes.hits.map((note, index) => (
                    <li key={note.name}>
                      <NoteResult
                        index={index}
                        note={mergeHighlightResult(note)}
                        onClick={(data) => onNoteClick({
                          ...data,
                          queryID: notes.queryID,
                          indexName: notes.indexName,
                        })}
                      />
                    </li>
                  ))
                }
              </ul>
            )
            : (
              <Message tag="div" className={s.notFound} text={messages.notFound.notes} values={{ query }} />
            )
        }
      </div>
      <div className={cx(s.section, s.pages, { [s.empty]: isPagesEmpty })}>
        <Message tag="div" className={s.title} text={messages.pages} />
        {
          !isPagesEmpty
            ? (
              <ul className={s.list}>
                {
                  pages.hits.map((page, index) => (
                    <li key={page.name}>
                      <PageResult
                        index={index}
                        page={mergeHighlightResult(page)}
                        onClick={(data) => onPageClick({
                          ...data,
                          queryID: pages.queryID,
                          indexName: pages.indexName,
                        })}
                      />
                    </li>
                  ))
                }
              </ul>
            )
            : (
              <Message tag="div" className={s.notFound} text={messages.notFound.pages} values={{ query }} />
            )
        }
      </div>
    </div>
  )
}

const algoliaShape = {
  queryID: PropTypes.string,
  hits: PropTypes.array,
  indexName: PropTypes.string,
}

SearchResults.propTypes = {
  query: PropTypes.string,
  isFirstLoaded: PropTypes.bool,
  onProductClick: PropTypes.func,
  onProductAdd: PropTypes.func,
  onBrandClick: PropTypes.func,
  onNoteClick: PropTypes.func,
  onPageClick: PropTypes.func,

  // @connect
  items: PropTypes.shape({
    products: PropTypes.shape(algoliaShape),
    brands: PropTypes.shape(algoliaShape),
    notes: PropTypes.shape(algoliaShape),
    pages: PropTypes.shape(algoliaShape),
  }),
}


export default compose(
  connect({
    items: 'models.search.algoliaItems',
  })
)(SearchResults)
